import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function ServiceDetailPage() {
  useEffect(() => {
    // Scroll to top when this page is mounted
    window.scrollTo(0, 0);
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const services = [
    {
      id: 1,
      title: "Private Market Research",
      img: "/first.svg",
      desc1:
        "We deliver deep intelligence across key private market asset classes including Private Equity, Private Capital, Private Debt, Venture Capital, Real Estate, Hedge Funds, Commodities, and Futures. Our research mandate includes company profiling, financial statement analysis, and risk and gap assessments to evaluate the performance, financial health, and forward outlook of organisations. We examine core financial disclosures such as income statements, balance sheets, cash flow statements, and statements of changes in equity.",
      desc2: "A core strength of our work is our expertise in the investor–fund manager relationship within Private Equity, specifically the connection between General Partners (GPs) and Limited Partners (LPs). We directly engage with general partners, limited partners, advisors, lawyers, regulators, and financiers who influence how capital enters and exits the asset class. From these conversations we produce a carefully balanced mix of digital news, commentary, and analysis on the dominant trends shaping Private Equity. Our work is supported by a proprietary database of funds, fund managers, and their investors, which forms an integral part of our digital research offering.",
    },
    {
      id: 2,
      title: "Capital Market Research",
      img: "/second.svg",
      desc1: "We conduct in-depth equity research across financial assets such as listed shares and mutual fund portfolios. We analyse financial reports, annual filings, and recent investment transactions. We also extract key data such as Assets Under Management (AUM) to deliver actionable insights on future investment opportunities.",
      desc2: "As part of our offering, Digital Ledger Media prepares investment summary articles for clients. These summaries are used on investment portals and are referenced by leading organisations in the capital markets ecosystem.",
    },
    {
      id: 3,
      title: "Commodities Intelligence",
      img: "/third.svg",
      desc1: "We deliver intelligence on commodities such as oil and gas, metals, mining, and chemicals, as well as on derivative instruments including futures and options. Commodity prices are highly sensitive to political, economic, and even weather-related developments.",
      desc2: "We keep your information products current with ongoing research and insight on all these market-moving variables.",
    },
    {
      id: 4,
      title: "Sustainable Investment Research",
      img: "/four.png",
      desc1: "We help investors make confident and responsible decisions in a market that is rapidly shifting toward sustainability. ",
      desc2: "Our research goes beyond surface-level ESG scores and uncovers how environmental, social, and governance factors influence returns, risk, and regulatory acceptance. We analyse ESG-aligned companies and funds, including managed funds and different ESG fund types. We study ESG themes, global sustainability trends, ESG and impact associations, and ESG policies to convert complex information into clear and actionable intelligence. Our insights give clients a competitive advantage in identifying credible impact opportunities while staying aligned with global standards.",
    },
  ];

  return (
    <div className="container py-5 mt-4">
      {/* Heading Motion */}
      <motion.h1
        className="fw-bold mb-5 text-center"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        Our Research Services
      </motion.h1>

      {services.map((item, index) => (
        <motion.div
          key={item.id}
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className={`mb-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-4 ${
            index % 2 !== 0 ? "flex-md-row-reverse" : ""
          }`}
        >
          {/* IMAGE */}
          <motion.div
            className="col-12 col-md-6 d-flex justify-content-center"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <motion.img
              src={item.img}
              alt={item.title}
              style={{
                width: "100%",
                maxWidth: "500px",
                height: "260px",
                objectFit: "cover",
                borderRadius: "12px",
                transition: "all 0.4s ease",
              }}
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 10px 20px rgba(0,0,0,0.25)",
              }}
            />
          </motion.div>

          {/* TEXT */}
          <motion.div
            className="col-12 col-md-6"
            initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <h4 className="fw-bold mb-2">
              {item.id}. {item.title}
            </h4>
            <p className="text-muted mb-1">{item.desc1}</p>
            {item.desc2 && <p className="text-muted">{item.desc2}</p>}
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
}
